import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { eventTimeline } from "@/mocks/news";

const levelStyle = (level: string) => {
  if (level === "官方口径") return "bg-secondary-100 text-secondary-900 border-secondary-300";
  if (level === "可核对") return "bg-accent-100 text-accent-900 border-accent-300";
  return "bg-background-200 text-foreground-700 border-background-300";
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-[0.9fr_1.4fr] lg:gap-16">
        <Reveal className="w-full">
          <div className="lg:sticky lg:top-32">
            <span className="label-font text-xs uppercase tracking-[0.24em] text-primary-600">
              Full Timeline
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              事件时间线
              <span className="mt-1 block text-base font-bold text-foreground-500 md:text-lg">
                把前后矛盾的说法按日期重排
              </span>
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              以「顾沉合约风波」为例，把从首条传闻到物料撤换的每一个节点按时间排列，并标注每个节点的依据类型。
              多数真实变化发生在只出现动作、不出现文字的那几天，这一段恰恰最少被报道。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full border border-secondary-300 bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                <i className="ri-verified-badge-line" />
                官方口径
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full border border-accent-300 bg-accent-100 px-3 py-1 text-xs text-accent-900">
                <i className="ri-file-search-line" />
                可核对
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full border border-background-300 bg-background-200 px-3 py-1 text-xs text-foreground-700">
                <i className="ri-question-line" />
                低可信
              </span>
            </div>

            <Link
              to="/article/gu-chen-contract-timeline"
              className="mt-7 inline-flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              阅读完整时间线解读
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </Reveal>

        <ol className="relative w-full border-l border-background-300 pl-6 md:pl-8">
          {eventTimeline.map((node, index) => (
            <li key={`${node.date}-${node.title}`} className="relative pb-8 last:pb-0">
              <Reveal delay={index * 70}>
                <span className="absolute -left-[31px] top-1.5 flex h-4 w-4 items-center justify-center md:-left-[39px]">
                  <span
                    className={`h-3 w-3 rounded-full border-2 ${
                      index === eventTimeline.length - 1
                        ? "border-primary-500 bg-primary-500"
                        : "border-background-400 bg-background-50"
                    }`}
                  />
                </span>
                <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="label-font text-sm font-semibold text-foreground-950">
                      {node.date}
                    </span>
                    <span className="text-xs text-foreground-500">{node.time}</span>
                    <span
                      className={`rounded-full border px-2.5 py-0.5 text-[11px] ${levelStyle(node.level)}`}
                    >
                      {node.level}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-bold text-foreground-950">
                    {node.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}